/**
 * 화면 구현
 */
import { SbsPlayerGlobal } from '../../common';
import SbsPlayerLogger from '../../utils/logger';

customElements.define(
  'sbs-player-dialog-button',
  class extends HTMLElement {
    constructor() {
      super();
      this.visible = false;
    }

    set visible(value) {
      this._visible = value;
      this.render();
    }

    get visible() {
      return this._visible;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        this.innerHTML = `<!-- 유료영상 동시 재생 및 접속 제한 : PC -->
        <div class="playerLayerConnect_w current" role="dialog"><!-- current 추가시 노출 / 활성화 시 다른 영역의 안보이는 요소들 태그들에 ari-hidden="true" 를 제공해야함. -->
          <div class="playerLayerContents">
            <strong class="playerLayer-title">안내</strong>
            <p class="playerLayer-text">동시재생 가능 기기 수를 초과했습니다.<br>현재 기기에서 다시보기를 시청하시면 다른기기에서 재생이 중지됩니다.<br>시청하시겠습니까?</p>
            <p class="playerLayer-text">고객센터 1577-1003<br>(평일 AM9시~ PM6시)</p>
            <div class="playerLayerBtns_w">
              <a href="javascript:void(0);" class="btn_text">시청재개</a>
              <a href="javascript:void(0);" class="btn_text">닫기</a>
            </div>
        </div>`;
        this.styles();
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        const buttons = this.querySelectorAll('a[class^="btn_text"]');
        buttons[0]?.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.reload();
        });
        buttons[1]?.addEventListener('click', (e) => {
          e.preventDefault();
          SbsPlayerGlobal.view
            .querySelector('sbs-player-dialog-button')
            .remove();
          if (
            document.referrer &&
            document.referrer.indexOf(window.location.host) !== -1
          ) {
            history.back();
          } else {
            window.location.href =
              window.location.protocol + '//' + window.location.host;
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
);
